import React, { useState } from "react";
import "../HelpCenter/HelpCenter.scss";
import { styled, TextareaAutosize, TextField } from "@mui/material";
import { PrimaryButton } from "../../components/AllButtons/AllButtons";
import EmailIcon from "../../assets/images/vactor/sms-icon.svg";
import CallIcon from "../../assets/images/vactor/call-icon.svg";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { sendQuery } from "../../Services/profile.service";
import { openSnackbar } from "../../Slice/snackbarSlice";
// textarea
const Textarea = styled(TextareaAutosize)(
  ({ theme }) => `
          box-sizing: border-box;
          width: 100%;
          font-family: 'Inter', 'sans-serif';
          font-size: 16px;
          font-weight: 400;
          line-height: 1.5;
          padding: 8px 14px;
          border-radius: 8px;
          border-color:#E2E4E9;
          color:#0A0D14;
      
          &:placeholder{
          color:#E2E4E9;
          }
          // firefox
          &:focus-visible {
            outline: 0;
          }
        `
);

const HelpCenter = () => {
  const dispatch = useAppDispatch();
  const userName = useAppSelector((state) => state.user.user);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [messageError, setMessageError] = useState('');


  const formatPhoneNumber = (value: string) => {
    const cleaned = value.replace(/[^\d+]/g, '');
    if (cleaned.startsWith('+')) {
      const digits = cleaned.slice(1).replace(/\D/g, '');
      const countryCode = digits[0] === '1' ? '1' : '';
      const phoneDigits = digits.slice(countryCode ? 1 : 0).slice(0, 10);
      const parts = [];
      if (phoneDigits.length > 0) parts.push(`(${phoneDigits.slice(0, 3)}`);
      if (phoneDigits.length > 3) parts.push(`) ${phoneDigits.slice(3, 6)}`);
      if (phoneDigits.length > 6) parts.push(`-${phoneDigits.slice(6, 10)}`);
      
      return `+1${parts.join('')}`.replace('+1(', '+1 (');
    }

    const digits = cleaned.replace(/\D/g, '').slice(0, 10);
    const parts = [];
    if (digits.length > 0) parts.push(`(${digits.slice(0, 3)}`);
    if (digits.length > 3) parts.push(`) ${digits.slice(3, 6)}`);
    if (digits.length > 6) parts.push(`-${digits.slice(6, 10)}`);
    
    return parts.join('');
  };
  
  const validatePhoneNumber = (number: string) => {
    const digits = number.replace(/\D/g, '');
    return digits.length === (number.startsWith('+') ? 11 : 10);
  };
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const formatted = formatPhoneNumber(input);
    setPhoneNumber(formatted);
    setError('');
  };

  const handleBlur = () => {
    if (phoneNumber && !validatePhoneNumber(phoneNumber)) {
      setError('Please enter a valid US phone number');
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!phoneNumber.trim()) {
      setError('Phone number is required');
      return;
    } else if (!validatePhoneNumber(phoneNumber)) {
      setError('Please enter a valid US phone number');
      return;
    } else {
      setError('');
    }
    if (!message.trim()) {
      setMessageError('Message is required');
      return;
    } else {
      setMessageError('');
    }
    if (phoneNumber && !validatePhoneNumber(phoneNumber)) {
      setError('Please enter a valid US phone number');
      return;
    }
    const queryObj = {
      name : userName.name ,
      email : userName.email ,
      phone :  phoneNumber.replace(/[^\d+]/g, '') ,
      message : message
    }
    dispatch(sendQuery(queryObj)).unwrap().then((response : any  ) => {
      if(response.status){
        dispatch(openSnackbar({message : response.message , severity  : "success"}))
      }
      else{
        dispatch(openSnackbar({message : response.message , severity  : "error"}))
      }
    }).catch((error) => {
      dispatch(openSnackbar({message : "Something went wrong" + error , severity  : "error"}))
    }) ; 
    
  };

  const handleMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setMessage(value);
    if (value.trim() && messageError) {
      setMessageError('');
    }
  };
  return (
    <>
      <section className="help-center-wrapper">
        <div className="row">
          <div className="col-md-12">
            <div className="help-center-header">
              <h4 className="help-center-header-title">
                Need Help? Contact Us!
              </h4>
              <p className="help-center-header-dsc">
                We're here to assist you. Reach out via email, phone, or submit
                your query below.
              </p>
            </div>
          </div>
        </div>
        <div className="row gy-4">
          <div className="col-md-7 col-lg-8">
            <div className="help-center-card">
              <div className="query-form-title">Send Us a Query</div>
              <div className="query-form-block">
                <form action="">
                  <div className="input-form-field-wrapper">
                    <label htmlFor="">Name</label>
                    <TextField
                      className="out-label-input-text"
                      id="name"
                      name="name"
                      value={userName?.name}
                      disabled={true}
                      placeholder="Your name (optional)"
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      type="text"
                    />
                  </div>

                  <div className="input-form-field-wrapper">
                    <label htmlFor="">
                      Email Address 
                    </label>
                    <TextField
                      className="out-label-input-text"
                      id="name"
                      name="name"
                      value={userName?.email}
                      disabled={true}
                      placeholder="your@email.com"
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      type="text"
                    />
                  </div>

                  <div className="input-form-field-wrapper">
                    <label htmlFor="">Phone Number <span>*</span> </label>
                    <TextField
                      className="out-label-input-text"
                      id="phone"
                      name="phone"
                      value={phoneNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="+1 (234) 567-8901"
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      type="text"
                      error={!!error}
                      helperText={error}
                      inputProps={{
                        inputMode: 'tel',
                        maxLength: 20,
                      }}
                    />
                  </div>

                  <div className="input-form-field-wrapper">
                    <label htmlFor="">
                      Message <span>*</span>{" "}
                    </label>
                    <Textarea
                      aria-label="minimum height"
                      minRows={3}
                      placeholder="Type your message here... (500 characters max)"
                      name="message"
                      value={message}
                      onChange={handleMessageChange}
                      className={messageError ? 'error-border' : ''}
                    />
                    {messageError && (
                      <p className="error-message">{messageError}</p>
                    )}
                  </div>
                  <div className="query-form-action">
                    <PrimaryButton onClick={handleSubmit}>Send Query</PrimaryButton>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-5 col-lg-4">
            <div className="help-center-card-group">
              <div className="help-center-card ">
                <div className="contact-details-card">
                  <img src={EmailIcon} alt="" />
                  <h4 className="contact-details-label">Email Us</h4>
                  <p className="contact-details-value">support@yuli.com</p>
                </div>
              </div>
              <div className="help-center-card ">
                <div className="contact-details-card">
                  <img src={CallIcon} alt="" />
                  <h4 className="contact-details-label">Call Us</h4>
                  <p className="contact-details-value">+1-234-567-8901</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HelpCenter;
